// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__36qqs","cell":"ColumnAccessor_cell__1IkIU","firstCellAccent":"ColumnAccessor_firstCellAccent__2kvyT"};